import { makeAutoObservable } from 'mobx';

class Store {
    referer: string = '';

    constructor() {
        makeAutoObservable(this);
    }

    setReferer(ref: string) {
        this.referer = ref;
    }
}

export const store = new Store();